import { render, staticRenderFns } from "./ProductClassification.vue?vue&type=template&id=cdbbf392&"
import script from "./ProductClassification.vue?vue&type=script&lang=ts&"
export * from "./ProductClassification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports